import React from "react";
import "../../Styles/certified/s10.css";

export default function Finzly() {
  return (
    <>
      <div className="s10-certified-details-section">
        <div className="s10-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="s10-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="s10-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="s10-certified-badge"
            />
            <div className="s10-certified-company-names">
              <a href="https://www.s10health.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/s10/s10.png"
                alt="Walkzero Logo"
                className="s10-certified-company-logo"
              />
            </a>
              <h1 className="s10-certified-full-name">
               S10 Healthcare Solutions Pvt. Ltd
              </h1>
            </div>
          </div>
          
        </div>
        {/* Description section below */}
        <div className="s10-certified-description">
          <h2>
            Why S10 Healthcare Solutions Pvt. Ltd. is an Outstanding Workplaces
          </h2>
          <p>
            S10 Healthcare Solutions Pvt. Ltd. is a healthcare support services company specializing in revenue cycle management, medical billing, coding, claims processing, medical scribing, and related healthcare operations. The company is recognized as a global pioneer in virtual medical scribing, being among the first organizations to provide virtual medical scribe services to healthcare providers.


          </p>
          <p>
            We are committed to delivering high-quality, technology-driven solutions that help healthcare organizations improve operational efficiency, enhance clinical documentation, optimize financial performance, and enable physicians to focus more on patient care. S10 fosters a positive, inclusive, and engaging workplace culture that supports employee growth, innovation, and excellence.
          </p>
          <p>
           Please note that due to HIPAA compliance requirements and our internal quality and security policies, we are unable to share photographs of our internal workspaces. We appreciate your understanding and respect for these confidentiality measures.

          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="s10-certified-info-cards">
          <div className="s10-certified-info-card">
            <div className="s10-certified-info-title">COMPANY SIZE</div>
            <div className="s10-certified-info-value">550 Employees</div>
          </div>
          <div className="s10-certified-info-card">
            <div className="s10-certified-info-title">INDUSTRY</div>
            <div className="s10-certified-info-value">ITES / Healthcare

</div>
          </div>
          <div className="s10-certified-info-card">
            <div className="s10-certified-info-title">CONNECT</div>
            <div className="s10-certified-info-icons">
              <span className="s10-certified-icon-round">
                <a href="https://www.s10health.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="s10-certified-icon-round">
                <a href="https://www.linkedin.com/company/s10-healthcare-solutions-pvt-ltd/?originalSubdomain=in" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="s10-certified-icon-round">
                <a href="https://www.facebook.com/S10healthishiring/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="s10-certified-info-card">
            <div className="s10-certified-info-title">LOCATION (HQ)</div>
            <div className="s10-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="s10-certified-recognition-section">
          <h2 className="s10-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="s10-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="s10-certified-recognition-image"
            />
          </div>
          <div className="s10-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        
      </div>
    </>
  );
}
